import { useState, useEffect } from "react";
import type { User } from "firebase/auth";
import { auth } from "./firebase";

let currentUser: User | null = null;
let isAuthReady = false;
const listeners = new Set<(user: User | null) => void>();

auth.onAuthStateChanged((user) => {
  currentUser = user;
  isAuthReady = true;
  listeners.forEach((listener) => listener(user));
});

const useActualUser = () => {
  const [user, setUser] = useState<User | null>(
    isAuthReady ? currentUser : auth.currentUser
  );
  const [isLoading, setIsLoading] = useState(!isAuthReady);

  useEffect(() => {
    if (isAuthReady) {
      setUser(currentUser);
      setIsLoading(false);
    }

    const handleChange = (newUser: User | null) => {
      setUser(newUser);
      setIsLoading(false);
    };

    listeners.add(handleChange);
    return () => {
      listeners.delete(handleChange);
    };
  }, []);

  const isLoggedIn = Boolean(user && user.emailVerified);

  return { user, isLoggedIn, isLoading };
};

export default useActualUser;